import { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
import { useDraftOrderStaff } from "../../state/draftOrderStaffState";
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { OrderItems } from "../../components/OrderItems";
import { BulkStaffEditDialog } from "./BulkStaffEditDialog";

const emptyItemState = { selected: [], core: [], accessory: [] };

export const BulkOrderItems = ({ order, staffInfo }) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);
  const [items, setItems] = useState(emptyItemState);
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const person = order?.data?.staff?.[0];
  const orderInfo = order?.data?.order;
  const orderNo = orderInfo?.no;
  const staffLineNo = person?.staffLineNo;

  const canLoadItems = Boolean(orderNo && typeof staffLineNo !== "undefined");

  const {
    data: staffLines,
    isPending,
    isSuccess,
  } = useDraftOrderStaff(orderNo, staffLineNo, canLoadItems);

  const successFunc = () => {
    const lines = staffLines?.data?.data?.data?.data?.lines;
    if (!lines) return;
    const selectedItems = lines.filter((line) => line.itemNo);
    const coreItems = lines.filter((line) => line.type === "Core");
    const accessoryItems = lines.filter((line) => line.type === "Accessory");
    setItems({
      selected: selectedItems,
      core: coreItems,
      accessory: accessoryItems,
    });
  };

  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${staffLines?.data?.status}: ${staffLines?.data?.statusText}`,
      severity: "error",
    });

  useCheckAPI(
    isSuccess,
    staffLines,
    staffLines?.data?.status,
    successFunc,
    errorFunc,
  );

  const itemsCount = person?.numberOfLines || items.selected.length;

  if (!person) {
    return (
      <Box>
        <Typography variant="body2">
          Staff information is required before adding items.
        </Typography>
      </Box>
    );
  }

  if (!orderNo) {
    return (
      <Box>
        <Typography variant="body2">
          Create or resume a bulk order to start adding items.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <OrderItems
        person={person}
        order={orderInfo}
        items={items}
        loading={isPending}
        staffRequest={false}
        inlineMode
        itemsCount={itemsCount}
        orderType="bulk"
        onEditDetails={() => setEditDialogOpen(true)}
      />
      <BulkStaffEditDialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        staffData={staffInfo}
      />
    </Box>
  );
};
